/* global axios */
import ApiClient from '../ApiClient';

class SlackChannel extends ApiClient {
  constructor() {
    super('slack', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new SlackChannel();
